import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import TableWrapper from "../TableWrapper";
import { Statuses } from "../../../constants/common";
import { GetAppointmentApprovalStatusesByIdResponse } from "../../../hooks/visitor/interface";
import { cn } from "../../../utils/cn";
import { useTranslation } from "react-i18next";

interface ApprovalStatusesTableProps {
  approvalStatuses?: GetAppointmentApprovalStatusesByIdResponse[];
}

const ApprovalStatusesTable = ({
  approvalStatuses,
}: ApprovalStatusesTableProps) => {
  const { t, i18n } = useTranslation();

  const approvalStatusesColumns: ColumnDef<GetAppointmentApprovalStatusesByIdResponse>[] =
    [
      {
        accessorKey: "s_RoleName",
        header: t("approver"),
        cell: ({ row }) => {
          return (
            <span>
              {i18n.language === "en"
                ? row.original.s_RoleName
                : row.original.s_RoleNameAr}
            </span>
          );
        },
      },
      {
        accessorKey: "firstname",
        header: t("approvedBy"),
        cell: ({ row }) => {
          return <span>{row.original.firstname}</span>;
        },
      },
      {
        accessorKey: "Comment",
        header: t("comment"),
        cell: ({ row }) => {
          return <span>{}</span>;
        },
      },
      {
        accessorKey: "dt_ApprovalDate",
        header: t("date"),
        cell: ({ row }) => {
          return <span>{row.original.dt_ApprovalDate}</span>;
        },
      },
      {
        accessorKey: "descriptionEn",
        header: t("status"),
        cell: ({ row }) => {
          return (
            <div
              className={cn(
                "text-center rounded-lg px-2 py-0.5 mx-auto",
                row.original.descriptionEn === Statuses.APPROVED
                  ? "bg-green-600"
                  : row.original.descriptionEn === Statuses.PENDING
                  ? "bg-yellow-500"
                  : "bg-red-500"
              )}
            >
              <p className="text-white">
                {i18n.language === "en"
                  ? row.original.descriptionEn
                  : row.original.descriptionAr}
              </p>
            </div>
          );
        },
      },
    ];
  return (
    <TableWrapper
      data={approvalStatuses}
      columns={approvalStatusesColumns}
      isPagination={false}
      isColumnChooser={false}
    />
  );
};

export default React.memo(ApprovalStatusesTable);
